import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/n/_auth/settings/_layout/')({
  beforeLoad: () => {
    throw redirect({
      to: '/n/settings/account-and-security',
      replace: true,
    });
  },
});
